// Copyright ©️ 2026 eVolve MEP, LLC

import { TextInput } from '@mantine/core';

import { useBendCreatorFormContext } from '../Context/useBendCreatorFormContext';
import { BendQuantityStepper } from './BendQuantityStepper';

export const BendReviewFields = () => {
  const { getInputProps } = useBendCreatorFormContext();
  return (
    <>
      <TextInput
        label="Part Name"
        required
        size="xl"
        styles={{ label: { fontSize: 'var(--mantine-font-size-sm)' } }}
        {...getInputProps('partName')}
      />
      <BendQuantityStepper
        label="Quantity"
        required
        size="xl"
        styles={{ label: { fontSize: 'var(--mantine-font-size-sm)' } }}
        {...getInputProps('quantity')}
      />
    </>
  );
};
